<template>
  <lb-drawer 
    :value="value" 
    @input="$emit('input', $event)"
    heading="Frequently Asked Question" 
    Maxwidth="50%" 
    :loading="loading" 
    :sidePeekDefault="true" 
    data-testid="materiality-faq__drawer"
  >
    <template v-slot:body>
      <div class="d-flex flex-column gap-6">
        <div>
          <h6 class="mb-1 font-semibold faqCardtitle">What is materiality? How can I update this?</h6>
          <v-card class="pa-3 defaultcard faqcard" elevation="0" outlined>
            Materiality involves establishing specific thresholds (values or percentages) at the local or regional level by Tool Admin Preparers. These thresholds help identify GL's that exceed the control or management threshold set based on the materiality criteria.The numbers in the application will be in USD and hence the thresholds are expected to be in USD.For a detailed explanation and step by step instruction, please refer the section in the user manual on 'Materiality'
          </v-card>
        </div>
        <div>
          <h6 class="mb-1 font-semibold faqCardtitle">What should I do if I encounter issues with the Materiality feature, such as being unable to set it up or view specific GLs?</h6>
          <v-card class="pa-3 defaultcard faqcard" elevation="0" outlined>
            <div class="faqcard">1. Refresh the screen and try in 10 minutes</div> 
            <div class="faqcard">2. If issues persist, reach out to the Consark Support Team with the issue and screenshot if any</div>
          </v-card>
        </div>
        <div>
          <h6 class="mb-1 font-semibold faqCardtitle">Should I enter Materiality in both the absolute numbers and Percentage or just choose one of them ?</h6>
          <v-card class="pa-3 defaultcard faqcard" elevation="0" outlined>
           Starlight Application is designed to compare the materiality set in absolute numbers and the percentage and then, apply the lower of the two in flagging off commentary requirements against every Account Code.
          </v-card>
        </div>
      </div>
    </template>
  </lb-drawer>
</template>

<script>
export default {
  name: 'MaterialityFAQ',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.faqcard {
 font-size:var(--font-size-xxs);
}
.faqCardtitle{
  font-size:var(--font-size-xxs);
  font-weight:600;
}
</style>
